import PropTypes from "prop-types";
import { childrenPropType, classNamePropType } from "../../common";

/**
 * PropTypes for Tooltip component
 *
 * @property {React.ReactNode} [children] - Tooltip trigger element
 * @property {string|React.ReactNode} [content] - Tooltip content text or element
 * @property {string} [className] - Additional CSS classes
 * @property {('top'|'bottom'|'left'|'right')} [placement] - Tooltip placement relative to trigger
 * @property {('hover'|'click'|'focus')} [trigger] - Trigger mode for tooltip
 * @property {number} [delay] - Show delay in milliseconds
 */
export const tooltipPropTypes = {
  children: childrenPropType,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: classNamePropType,
  placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  trigger: PropTypes.oneOf(["hover", "click", "focus"]),
  delay: PropTypes.number,
};
